import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

/**
 * Initialise store values
 * @param {object} predicate
 * @returns void
 */
export const usePredicateStoreInit = (predicate) => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const init = useStore(store, (s) => s.init);

    return init;
};
